<template>
  <section class="become">
    <section class="view_cover">
      <div class="cover_img">
        <img src="../../assets/img/become_cover.png" />
        <h2>Become volunteer</h2>
        <p>We need you, Help us around</p>
      </div>
    </section>
    <div class="container">
      <section>
        <div class="content_2">
          <h2>Volunteer at our organization</h2>
          <p>
            Much obliged to you for your advantage in chipping in at one of our X
            organizations. We have different open doors for you to get included and
            volunteer at our schools, if it's not too much trouble see the subtleties
            beneath and get in touch with us at info@XYZ.com.bd
          </p>
        </div>
      </section>
      <section>
        <div class="post_body">
          <div class="row" data-aos="zoom-in">
            <div class="col-6">
              <div class="card_text">
                <h2>Teaching</h2>
                <figure><img src="../../assets/img/become_1.png" /></figure>
                <p>
                  Volunteers can work alongside local teachers to enrich the students’
                  learning experience. Individuals who are energetic, enthusiastic and
                  patient are best fitted for this volunteer position. A skill set to
                  teach subjects such as English, mathematics and science qualifies you
                  for the job!
                </p>
              </div>
            </div>
            <div class="col-6">
              <div class="card_text">
                <h2>Workshops</h2>
                <figure><img src="../../assets/img/become_2.png" /></figure>
                <p>
                  Qualified volunteers can conduct workshops on teaching methods for the
                  teaching staff as well as carry out community based workshops on
                  pressing topics such as hygiene, family life, and finance.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="post_body">
          <div class="row" data-aos="zoom-in">
            <div class="col-6">
              <div class="card_text">
                <h2>Curriculum Development</h2>
                <figure><img src="../../assets/img/become_3.png" /></figure>
                <p>
                  Volunteers can work alongside local teachers to enrich the students’
                  learning experience. Individuals who are energetic, enthusiastic and
                  patient are best fitted for this volunteer position. A skill set to
                  teach subjects such as English, mathematics and science qualifies you
                  for the job!
                </p>
              </div>
            </div>
            <div class="col-6">
              <div class="card_text">
                <h2>Extracurricular Activities</h2>
                <figure><img src="../../assets/img/become_4.png" /></figure>
                <p>
                  Qualified volunteers can conduct workshops on teaching methods for the
                  teaching staff as well as carry out community based workshops on
                  pressing topics such as hygiene, family life, and finance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="become_drop"
        v-for="(becomes, section_index) in Become_Data"
        :key="section_index"
      >
        <div class="container">
          <h2>{{ becomes.title }}</h2>
          <div class="become_body">
            <div v-for="(become, data_index) in becomes.data" :key="data_index">
              <div class="row">
                <div @click="Become_Click(section_index, data_index)" class="col">
                  <div class="drop_body">
                    <h4 class="">{{ become.question }}</h4>
                    <div class="dropicon">
                      <span>
                        <b
                          v-if="
                            currentSection == section_index && currentData == data_index
                          "
                        >
                          <i class="fas fa-angle-up"></i>
                        </b>
                      </span>
                      <span>
                        <b
                          v-if="
                            currentSection != section_index || currentData != data_index
                          "
                        >
                          <i class="fas fa-angle-down"></i>
                        </b>
                      </span>
                    </div>
                    <div
                      class="animated"
                      v-if="currentSection == section_index && currentData == data_index"
                    >
                      <p>{{ become.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      //currentFAQs: 1,
      currentSection: -1,
      currentData: -1,
      Become_Data: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.Become_Data = [
        {
          title: "Good To Know Before Coming",
          data: [
            {
              question: "Flights",
              answer:
                "The Arrival Airport in Dhaka is Hajrat Shahjalal International Airport [formerly known as Zia Intl Airport].",
            },
            {
              question: "Travel Insurance",
              answer:
                "The Arrival Airport in Dhaka is Hajrat Shahjalal International Airport [formerly known as Zia Intl Airport].",
            },
            {
              question: "Passports",
              answer:
                "The Arrival Airport in Dhaka is Hajrat Shahjalal International Airport [formerly known as Zia Intl Airport].",
            },
            {
              question: "Visas",
              answer:
                "The Arrival Airport in Dhaka is Hajrat Shahjalal International Airport [formerly known as Zia Intl Airport].",
            },
            {
              question: "Visas",
              answer:
                "The Arrival Airport in Dhaka is Hajrat Shahjalal International Airport [formerly known as Zia Intl Airport].",
            },
          ],
        },
      ];
    },
    Become_Click(section_index, data_index) {
      if (this.currentSection == section_index && this.currentData == data_index) {
        this.currentSection = -1;
        this.currentData = -1;
      } else {
        this.currentSection = section_index;
        this.currentData = data_index;
      }
    },
  },
};
</script>
<style scoped>
.become_drop .drop_body p,
.animated {
  animation: growDown 300ms ease-in-out forwards;
}
@keyframes growDown {
  0% {
    transform: rotateX(-90deg);
  }
  70% {
    transform: rotateX(20deg);
  }
  100% {
    transform: rotateX(0deg);
  }
}
.become .content_2 {
  width: 60%;
  padding: 60px 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.become .content_2 h2 {
  padding: 20px 0px;
  color: #07cddb;
}
.become .post_body h2 {
  padding: 20px 0px;
}
.become_drop .drop_body {
  margin-bottom: 20px;
  border-radius: 6px;
  opacity: 1;
  padding: 20px 30px;
}
.dropicon {
  float: right;
  position: relative;
  margin-top: -28px;
}
.become_drop .drop_body h4 {
  cursor: pointer;
}
.become_drop h2 {
  text-align: center;
  padding: 60px 0px;
}
.become_drop .drop_body p {
  margin-bottom: 0px;
  margin-top: 10px;
  font-weight: 500;
}
.become_drop {
  padding: 20px 40px 70px 40px;
}
.become .dropicon i {
  font-size: 18px;
  color: #07cddb;
}
.become .post_body {
  margin-bottom: 1.5rem;
}
</style>
